export default "__VITE_ASSET__QCw8E2oI__"